(ns pfo.weblink.model
  (:require [secretary.core :as secretary :refer-macros [defroute]]
            [promesa.core :as p]
            [pfo.api :as api]
            [pfo.common.component :refer [empty-page]]))

(defn direct-link [version data]
  (api/ajaxp (str "/weblink/direct/" version "/" data "/") {}))
